import { getElementRef } from '../utils/getElementRef'

export class ClearValuePlugin {
    constructor() {
        this.ref = {}
    }

    options() {
        return {
            clearvalueTemplate: `<button class="Select-clearValue" data-clearvalue>X</button>`,
        }
    }

    setup(inst) {
        this.inst = inst

        this.ref.clearValue = getElementRef(this.inst.element, "clearvalue", this.inst.options)
        this.ref.clearValue.addEventListener('click', this.handleClearValueClick)
        //do whatever with the select
    }

    handleClearValueClick = event => {
        event.preventDefault()

        this.inst.selectChoiceByValue('')
    }
}